import { Loader2 } from "lucide-react";

export default function GlobalLoader({ show }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white/70 dark:bg-black/60 backdrop-blur-sm">
      <div className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-white px-5 py-4 shadow-lg dark:border-slate-800 dark:bg-slate-950/70">
        <Loader2 className="h-5 w-5 animate-spin text-slate-700 dark:text-slate-200" />
        <span className="text-sm text-slate-800 dark:text-slate-100">
          Завантаження...
        </span>
      </div>
    </div>
  );
}
